<template>
  <AuthLayout>
    <template #title> Inscription </template>
    <template #subTitle> Renseignez vos infos pour continuer </template>
    <template #redirectQuestion> Déjà un compte? </template>
    <template #redirectLink>
      <router-link to="/login">Connectez-vous!</router-link>
    </template>
    <form
      class="space-y-6"
      v-bus:EVENTS.USER.REGISTER.submit.prevent
      v-redirect-on="{
        event: $constants.EVENTS.USER.REGISTER_SUCCESS,
        to: '/'
      }"
    >
      <!-- Nom et Prénom -->
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label class="block mb-1 font-medium text-gray-700">Nom</label>
          <input
            name="lastName"
            type="text"
            required
            class="inputComponent"
            placeholder="Votre nom"
          />
        </div>
        <div>
          <label class="block mb-1 font-medium text-gray-700">Prénom</label>
          <input
            name="firstName"
            type="text"
            required
            class="inputComponent"
            placeholder="Votre prénom"
          />
        </div>
      </div>

      <!-- Téléphone -->
      <div>
        <label class="block mb-1 font-medium text-gray-700">Numéro mobile money (très important)</label>
        <div class="flex gap-2">
          <Listbox
            v-model="selectedCountry"
            as="div"
            class="relative flex-1 max-w-[120px]"
          >
            <ListboxButton
              ref="countryButton"
              class="inputComponent w-full flex items-center gap-2 pr-2"
            >
              <img
                v-if="selectedCountry"
                :src="selectedCountry.flag"
                class="w-5 h-4 object-cover rounded-sm"
              />
              <!-- <span v-else class="text-gray-400">🌍</span> -->
              <span class="flex-1 text-left">{{
                selectedCountry?.code || 'Choisir'
              }}</span>
              <span class="text-gray-400">▼</span>
            </ListboxButton>
            <ListboxOptions
              class="absolute z-50 mt-1 max-h-60 w-auto min-w-full overflow-auto rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none text-sm"
            >
              <ListboxOption
                v-for="country in countries"
                :key="country.code"
                :value="country"
                class="relative cursor-pointer select-none py-2 pl-3 pr-9 hover:bg-gray-100 flex items-center gap-2 whitespace-nowrap"
              >
                <img
                  :src="country.flag"
                  class="w-5 h-4 object-cover rounded-sm"
                />
                <span class="font-medium">+{{ country.code }}</span>
                <span class="text-gray-500 ml-1">{{ country.name }}</span>
              </ListboxOption>
            </ListboxOptions>
          </Listbox>
          <input
            name="phoneNumber"
            type="tel"
            required
            class="flex-1! inputComponent"
            :placeholder="selectedCountry ? 'Ex: ' + selectedCountry.example : 'Choisir le pays'"
            @click="!selectedCountry && $refs.countryButton?.$el.click()"
            :readonly="!selectedCountry"
          />
          <input
            name="phonePrefix"
            type="hidden"
            :value="selectedCountry?.code || ''"
          />
        </div>
      </div>

      <!-- Email -->
      <div>
        <label class="block mb-1 font-medium text-gray-700">Email</label>
        <input
          name="email"
          type="email"
          required
          class="inputComponent"
          placeholder="email@exemple.com"
        />
      </div>

      <!-- Mot de passe -->
      <div>
        <label class="block mb-1 font-medium text-gray-700">Mot de passe</label>
        <input
          name="password"
          type="password"
          required
          class="inputComponent"
          placeholder="********"
        />
      </div>

      <!-- Code d'affiliation (Ce champ n'est pas obligatoire) -->
      <div>
        <label class="block mb-1 font-medium text-gray-700"
          >Code d'affiliation</label
        >
        <input
          name="affiliationCode"
          type="text"
          class="inputComponent"
          placeholder="Ce champ n'est pas obligatoire"
        />
      </div>

      <!-- Numéro WhatsApp (Ce champ n'est pas obligatoire) -->
      <div>
        <label class="block mb-1 font-medium text-gray-700"
          >Numéro WhatsApp</label
        >
        <input
          name="whatsappNumber"
          type="tel"
          class="inputComponent"
          placeholder="Ce champ n'est pas obligatoire"
        />
      </div>

      <!-- Cases à cocher -->
      <div class="space-y-3">
        <label class="flex items-center">
          <input
            name="acceptMoreThan18"
            type="checkbox"
            required
            class="mr-2"
          />
          <span class="text-sm">J'ai plus de 18 ans</span>
        </label>

        <label class="flex items-center">
          <input name="termOfUse" type="checkbox" required class="mr-2" />
          <span class="text-sm">
            J'accepte les
            <a
              :href="$stores.appData?.state?.data?.appInfo?.general?.cguUrl || 'https://1bpay.me/cgu'"
              target="_blank"
              class="underline text-primary"
            >
              conditions d'utilisation
            </a>
          </span>
        </label>
      </div>

      <!-- Bouton continuer -->
      <button
        type="submit"
        class="buttonComponent w-full"
        :disabled="$stores?.user?.state?.loading"
        :loading="$stores?.user?.state?.loading"
      >
        S'inscrire
      </button>
    </form>
  </AuthLayout>
</template>

<script setup>
import { ref } from 'vue';
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption
} from '@headlessui/vue';
import { COUNTRIES as countries } from '@features/shared/countries';

const selectedCountry = ref(null);
</script>
